// roundMixin.js
export const NumberUtilsMixing = {
    methods: {
        ceil(value, decimals = 2) {
            const factor = Math.pow(10, decimals);
            return Math.ceil(value * factor) / factor;
        },
    },
};
